import { render } from "./AddToCollection.vue?vue&type=template&id=75cf74a6"
import script from "./AddToCollection.vue?vue&type=script&lang=js"
export * from "./AddToCollection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__